import { AxiosInstance } from "axios";
import { DashboardFilterModel } from "Dashboard/models/DashboardFilterModel";
import { DashboardViewModel } from "Dashboard/models/DashboardViewModel";
import { isCancelled } from "helpers";
import { createLogger } from "logging";

const logger = createLogger("DashboardApi");

export class DashboardApi {
  constructor(private axios: AxiosInstance) {}

  async getBoards(filters: DashboardFilterModel): Promise<DashboardViewModel[]> {
    const url = "api/dashboard/boards";

    try {
      const response = await this.axios.post<DashboardViewModel[]>(url, filters);
      return response.data;
    } catch (error) {
      if (!isCancelled(error)) {
        logger.error("Failed to fetch boards", error);
      }

      throw error;
    }
  }
}
